/**
 * Account-activation feature strings.
 *
 * Namespace: accountActivation
 */
export const accountActivation = {
  // Page
  page: {
    title: "Jelszó beállítása",
    subtitle: "Hozza létre a fiókjához tartozó első jelszavát",
    checking: "Ellenőrzés…",
  },

  // Form fields
  form: {
    passwordLabel: "Új jelszó",
    passwordPlaceholder: "••••••••",
    passwordHelperText: "Legalább 8 karakter",
    confirmPasswordLabel: "Jelszó megerősítése",
    confirmPasswordPlaceholder: "••••••••",
    submitButton: "Jelszó beállítása",
  },

  // Errors
  errors: {
    invalidLink: "Az aktiválási link érvénytelen vagy lejárt.",
    // A108 S7: shown under invalidLink when the link is missing or invalid — the page renders an
    // error card instead of redirecting silently to /login.
    invalidLinkGuidance: "Kérjen új meghívót a szervezete adminisztrátorától.",
    // A110 S4: the card's own subtitle for the invalid-link state. The page subtitle invites the
    // person to set a first password, which this link no longer allows.
    subtitle: "A jelszó beállítása nem sikerült.",
    goToLogin: "Tovább a bejelentkezéshez",
    recaptchaFailed: "reCAPTCHA ellenőrzés sikertelen. Kérjük, próbálja újra.",
  },
} as const;
